import React, { useState, useEffect } from 'react';
import { Menu, X, Download } from 'lucide-react';
import { navLinks } from '../mock';

export const YDD_LOGO = 'https://customer-assets-jai6qajn.emergentagent.net/job_reward-news-portal/artifacts/4pvy82lp_YDD%20WHITE%20LOGO-01.webp';

const Logo = () => (
  <a href="#home" className="flex items-center group">
    <img
      src={YDD_LOGO}
      alt="YDD.News — Your Daily Dose"
      className="h-11 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
      style={{ mixBlendMode: 'lighten' }}
    />
  </a>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0E0E11]/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`}>
      <nav className="container-ydd flex items-center justify-between h-[68px]">
        <Logo />
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="text-sm text-gray-300 hover:text-[var(--ydd-yellow)] transition-colors duration-200">
              {l.label}
            </a>
          ))}
        </div>
        <div className="hidden md:flex items-center gap-3">
          <a href="#download" className="btn-yellow px-5 py-2.5 text-sm flex items-center gap-2">
            <Download size={16} /> Get the App
          </a>
        </div>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>
      {open && (
        <div className="md:hidden bg-[#0E0E11] border-t border-white/10 px-5 py-4 flex flex-col gap-4">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-gray-200 hover:text-[var(--ydd-yellow)] transition-colors">
              {l.label}
            </a>
          ))}
          <a href="#download" onClick={() => setOpen(false)} className="btn-yellow px-5 py-2.5 text-sm text-center flex items-center justify-center gap-2">
            <Download size={16} /> Get the App
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
